export const QUERY_LIMIT_25: number = 25;
export const QUERY_LIMIT: number = 50;
export const QUERY_LIMIT_100: number = 100;
